import React, { useState, useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useHomepageStore } from '../store/homepageStore';
import { Therapist } from '../../../core/types';
import BottomNavBar from '../../../core/components/ui/BottomNavBar';
import SidebarNav from '../widgets/SidebarNav';
import TherapistList from '../widgets/TherapistList';
import { LogoSvg, CreditsPill } from '../../../core/components/ui';
import UpcomingTab from '../../appointments/pages/UpcomingTab';
import AssessmentsTab from '../../assessments/pages/AssessmentsTab';
import SettingsPage from '../../settings/pages/SettingsPage';

const IndexPage: React.FC = () => {
  const store = useHomepageStore();
  const user = store.retrieve();

  const [therapists, setTherapists] = useState<Therapist[]>([]);
  const [credits, setCredits] = useState(0);
  const [loading, setLoading] = useState(false);
  const { drawerOpen, setDrawerOpen, tabIndex, setTabIndex } =
  useOutletContext<{
    drawerOpen: boolean;
    setDrawerOpen: (v: boolean) => void;
    tabIndex: number;
    setTabIndex: (i: number) => void;
  }>();
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    const [t, c] = await Promise.all([
      store.fetchTherapists(),
      store.getSessionCredit(),
    ]);
    setTherapists(t);
    setCredits(c.quantity || 0);
    setLoading(false);
  };

  const renderTab = () => {
    switch (tabIndex) {
      case 0: return <TherapistList
      therapists={Array.isArray(therapists) ? therapists : []}
      loading={loading}
    />
      case 1: return <UpcomingTab />;
      case 2: return <AssessmentsTab />;
      case 3: return <SettingsPage embedded />;
      default: return null;
    }
  };

  const tabTitles = ['Therapists', 'Upcoming Sessions', 'Assessments', 'Settings'];

  return (
    <div className="page app-layout" style={{ minHeight: '100vh' }}>
     

      <div className="app-main">
        <div
          className="appbar"
          style={{
            position: 'sticky',
            top: 0,
            zIndex: 100,
          }}
        >
          {/* ← CHANGED: only show burger on mobile/tablet, hidden on laptop via CSS class */}
<button
  type="button"
  className="menu-toggle"   // your CSS already has @media(min-width:768px){ display:none }
  onClick={() => setDrawerOpen(true)}
  style={{ background: 'none', padding: 4, color: 'white', alignItems: 'center' }}
  aria-label="Open menu"
>
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round">
    <line x1="3" y1="12" x2="21" y2="12"/>
    <line x1="3" y1="6" x2="21" y2="6"/>
    <line x1="3" y1="18" x2="21" y2="18"/>
  </svg>
</button>
          <LogoSvg size={28} white />
          <span className="appbar-title" style={{ fontWeight: 300, fontSize: 17 }}>
            {tabTitles[tabIndex]}
          </span>

          {tabIndex === 0 && <CreditsPill credits={credits} />}
        </div>

        <div
  className="main-content"
  style={{
    flex: 1,
    overflowY: 'auto',
    minHeight: 0,
  }}
>
  {renderTab()}
</div>
        <BottomNavBar currentIndex={tabIndex} onTap={setTabIndex} />
      </div>
    </div>
  );
};

export default IndexPage;
